module.exports = __webpack_public_path__ + "public/images/psychology.d2a1f6856f09aeacf6b16ba62449b610.png";